"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class AskDataLensesApi extends runtime.BaseAPI {
    /**
     * Create an ask data lens. Permissions- This can be invoked by a user who has permission to create lens.
     * Create a lens
     */
    lensServiceCreateLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.publicrest.v1.CreateLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/askdata/lenses`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensPublicrestV1CreateLensRequestToJSON(requestParameters.tableauNlpLensPublicrestV1CreateLensRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensPublicrestV1CreateLensResponseFromJSON(jsonValue));
        });
    }
    /**
     * Create an ask data lens. Permissions- This can be invoked by a user who has permission to create lens.
     * Create a lens
     */
    lensServiceCreateLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensServiceCreateLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Delete an Ask Data lens. Permissions- This can be invoked by a user who has permission to delete a lens.
     * Delete a lens
     */
    lensServiceDeleteLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.lensId === null || requestParameters.lensId === undefined) {
                throw new runtime.RequiredError('lensId', 'Required parameter requestParameters.lensId was null or undefined when calling lensServiceDeleteLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/askdata/lenses/{lens_id}`.replace(`{${"lens_id"}}`, encodeURIComponent(String(requestParameters.lensId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete an Ask Data lens. Permissions- This can be invoked by a user who has permission to delete a lens.
     * Delete a lens
     */
    lensServiceDeleteLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.lensServiceDeleteLensRaw(requestParameters);
        });
    }
    /**
     * Get the details of a lens. Permissions - This method can be called by users who have read access to the lens.
     * Get ask data lens details
     */
    lensServiceGetLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.lensId === null || requestParameters.lensId === undefined) {
                throw new runtime.RequiredError('lensId', 'Required parameter requestParameters.lensId was null or undefined when calling lensServiceGetLens.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/askdata/lenses/{lens_id}`.replace(`{${"lens_id"}}`, encodeURIComponent(String(requestParameters.lensId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensPublicrestV1GetLensResponseFromJSON(jsonValue));
        });
    }
    /**
     * Get the details of a lens. Permissions - This method can be called by users who have read access to the lens.
     * Get ask data lens details
     */
    lensServiceGetLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensServiceGetLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * This API lets you import a lens in to the site. Useful when you want to publish a lens across projects, sites etc. The input to this API is a lens that already exist in a server. You can get the details of the lens using the getLens method and submit to this method. During an import, you can use transformations to apply on the exported lens. Permissions - This method can only be called by server administrators or site administrators.
     * Import a lens
     */
    lensServiceImportLensRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/vnd.tableau.nlp.lens.publicrest.v1.ImportLensRequest+json';
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/askdata/lenses/import`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.TableauNlpLensPublicrestV1ImportLensRequestToJSON(requestParameters.tableauNlpLensPublicrestV1ImportLensRequest),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensPublicrestV1ImportLensResponseFromJSON(jsonValue));
        });
    }
    /**
     * This API lets you import a lens in to the site. Useful when you want to publish a lens across projects, sites etc. The input to this API is a lens that already exist in a server. You can get the details of the lens using the getLens method and submit to this method. During an import, you can use transformations to apply on the exported lens. Permissions - This method can only be called by server administrators or site administrators.
     * Import a lens
     */
    lensServiceImportLens(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensServiceImportLensRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Returns a list of lenses in a site. Permissions - This method can be called by any user and they will see the lenses to which they have access to.
     * Get ask data lens list
     */
    lensServiceListLensesRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters.xTableauAuth !== undefined && requestParameters.xTableauAuth !== null) {
                headerParameters['X-Tableau-Auth'] = String(requestParameters.xTableauAuth);
            }
            const response = yield this.request({
                path: `/api/-/askdata/lenses`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.TableauNlpLensPublicrestV1ListLensesResponseFromJSON(jsonValue));
        });
    }
    /**
     * Returns a list of lenses in a site. Permissions - This method can be called by any user and they will see the lenses to which they have access to.
     * Get ask data lens list
     */
    lensServiceListLenses(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.lensServiceListLensesRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.AskDataLensesApi = AskDataLensesApi;
